/* =========================================================
   WHYTABS · Conversion kit · wt-core.js  (no dependencies)
   - Buy box: formula → pack → subscribe/one-time → /cart/add.js
   - PDP gallery thumbs
   - Mobile sticky add-to-cart
   ========================================================= */
(function () {
  'use strict';
  if (window.__wtCore) return; // asset may be included by several sections
  window.__wtCore = true;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || '${{amount}}';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = fmt(cents, 0); break;
      case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      default: val = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  function decodeFormat(str) {
    var t = document.createElement('textarea');
    t.innerHTML = str || '';
    return t.value;
  }

  function BuyBox(root) {
    this.root = root;
    this.money = decodeFormat(root.getAttribute('data-money-format'));
    this.atcAction = root.getAttribute('data-atc-action') || 'cart';
    this.labelSub = root.getAttribute('data-label-sub');
    this.labelOnce = root.getAttribute('data-label-once');
    this.packs = {};
    this.order = [];
    var self = this;

    root.querySelectorAll('[data-pack]').forEach(function (el) {
      var json = el.querySelector('[data-pack-json]');
      if (!json) return;
      try {
        var data = JSON.parse(json.textContent);
        data.el = el;
        self.packs[data.id] = data;
        self.order.push(data.id);
      } catch (e) { console.warn('[whytabs] bad pack json', e); }
    });
    if (!this.order.length) return;

    this.formulaBtns = root.querySelectorAll('[data-formula].wt-formula__opt');
    this.planEls = {
      subscribe: root.querySelector('[data-plan="subscribe"]'),
      onetime: root.querySelector('[data-plan="onetime"]')
    };
    this.freq = root.querySelector('[data-sub-freq]');
    this.atcButtons = root.querySelectorAll('[data-wt-atc]');
    this.errorEl = root.querySelector('[data-wt-error]');
    this.sticky = root.querySelector('[data-wt-sticky]');
    this.planStep = root.querySelector('[data-plan-step]');
    this.nudge = root.querySelector('[data-sub-nudge]');
    this.qtyInput = root.querySelector('[data-qty-input]');
    this.mode = root.getAttribute('data-mode') || 'packs';

    // Initial state
    var initial = root.getAttribute('data-initial');
    var formula = root.getAttribute('data-default-formula') || 'original';
    if (initial && this.packs[initial]) formula = this.packs[initial].formula;
    if (!this.order.some(function (id) { return self.packs[id].formula === formula; })) formula = this.packs[this.order[0]].formula;
    this.formula = formula;
    this.plan = root.getAttribute('data-default-plan') || 'subscribe';
    this.packId = (initial && this.packs[initial]) ? initial : this.bestPackFor(formula, null);

    // Events
    this.formulaBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { self.setFormula(btn.getAttribute('data-formula')); });
    });
    this.order.forEach(function (id) {
      self.packs[id].el.addEventListener('click', function (e) {
        if (self.packs[id].el.classList.contains('is-soldout')) return;
        e.preventDefault();
        self.packId = id; self.render();
      });
    });
    Object.keys(this.planEls).forEach(function (k) {
      var el = self.planEls[k];
      if (!el) return;
      el.addEventListener('click', function (e) {
        if (e.target === self.freq) return;
        e.preventDefault();
        if (k === 'subscribe' && self.nudgeTarget) { self.packId = self.nudgeTarget; }
        self.plan = k; self.render();
      });
    });
    if (this.freq) this.freq.addEventListener('change', function () { self.render(); });
    if (this.qtyInput) {
      var clamp = function (n) { return Math.max(1, Math.min(20, Number(n) || 1)); };
      root.querySelector('[data-qty-minus]').addEventListener('click', function () { self.qtyInput.value = clamp(Number(self.qtyInput.value) - 1); self.render(); });
      root.querySelector('[data-qty-plus]').addEventListener('click', function () { self.qtyInput.value = clamp(Number(self.qtyInput.value) + 1); self.render(); });
      this.qtyInput.addEventListener('change', function () { self.qtyInput.value = clamp(self.qtyInput.value); self.render(); });
    }
    this.atcButtons.forEach(function (b) { b.addEventListener('click', function () { self.addToCart(); }); });

    this.initSticky();
    this.render();
  }

  // Pick the same supply size when switching formula; otherwise the largest available pack.
  BuyBox.prototype.bestPackFor = function (formula, tablets) {
    var self = this;
    var candidates = this.order.map(function (id) { return self.packs[id]; })
      .filter(function (p) { return p.formula === formula && p.available; });
    if (!candidates.length) candidates = this.order.map(function (id) { return self.packs[id]; }).filter(function (p) { return p.formula === formula; });
    if (!candidates.length) return this.order[0];
    if (tablets) {
      var same = candidates.filter(function (p) { return p.tablets === tablets; })[0];
      if (same) return same.id;
    }
    candidates.sort(function (a, b) { return b.tablets - a.tablets; });
    return candidates[0].id;
  };

  BuyBox.prototype.setFormula = function (f) {
    var cur = this.packs[this.packId];
    this.formula = f;
    this.packId = this.bestPackFor(f, cur ? cur.tablets : null);
    this.render();
    this.root.dispatchEvent(new CustomEvent('wt:formula', { bubbles: true, detail: { formula: f } }));
  };

  BuyBox.prototype.currentPlan = function (pack) {
    if (!pack.plans || !pack.plans.length) return null;
    var id = this.freq && this.freq.value ? String(this.freq.value) : String(pack.plans[0].id);
    return pack.plans.filter(function (p) { return String(p.id) === id; })[0] || pack.plans[0];
  };

  BuyBox.prototype.render = function () {
    var self = this;
    var pack = this.packs[this.packId];
    if (!pack) return;
    var m = function (c) { return formatMoney(c, self.money); };

    // Formula buttons
    this.formulaBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-formula') === self.formula)); });

    // Packs
    this.order.forEach(function (id) {
      var p = self.packs[id];
      p.el.hidden = p.formula !== self.formula;
      p.el.classList.toggle('is-selected', id === self.packId);
      var input = p.el.querySelector('input'); if (input) input.checked = id === self.packId;
      // Row price + $/tablet follow the chosen purchase type and round the same way as the summary line.
      var unitEl = p.el.querySelector('[data-pack-unit]'), priceEl = p.el.querySelector('[data-pack-price]');
      if (unitEl && p.tablets > 0) {
        var basis = (self.plan === 'subscribe' && p.plans && p.plans.length) ? p.plans[0].price : p.price;
        if (priceEl) priceEl.textContent = m(basis);
        unitEl.textContent = m(Math.round(basis / p.tablets)) + '/tablet';
      }
    });

    // Subscription availability
    var hasPlans = pack.plans && pack.plans.length > 0;
    if (!hasPlans && this.plan === 'subscribe') this.plan = 'onetime';
    if (pack.requiresPlan && hasPlans) this.plan = 'subscribe';
    // Nudge: this pack can't be subscribed (e.g. a Shopify Bundle kit) but another pack of the same
    // formula can -> keep the Subscribe card visible and switch to that pack when chosen.
    this.nudgeTarget = null;
    if (!hasPlans) {
      var alt = this.order.map(function (id) { return self.packs[id]; })
        .filter(function (p) { return p.formula === pack.formula && p.available && p.plans && p.plans.length; })[0];
      if (alt) this.nudgeTarget = alt.id;
    }
    var showSub = hasPlans || !!this.nudgeTarget;
    if (this.planEls.subscribe) this.planEls.subscribe.hidden = !showSub;
    if (this.planEls.onetime) this.planEls.onetime.hidden = !!pack.requiresPlan;
    if (this.planStep) this.planStep.hidden = !showSub && !pack.requiresPlan;

    // Frequency select (only rebuild when pack changes)
    if (this.freq) {
      if (this.freq.getAttribute('data-for') !== pack.id) {
        var prevName = this.freq.selectedOptions && this.freq.selectedOptions[0] ? this.freq.selectedOptions[0].text : null;
        this.freq.innerHTML = '';
        (pack.plans || []).forEach(function (pl) {
          var o = document.createElement('option');
          o.value = pl.id; o.textContent = pl.name;
          if (prevName && prevName === pl.name) o.selected = true;
          self.freq.appendChild(o);
        });
        this.freq.setAttribute('data-for', pack.id);
      }
      this.freq.hidden = !hasPlans || pack.plans.length < 2 || this.plan !== 'subscribe';
    }

    var plan = this.currentPlan(pack);
    if (this.nudge) {
      var alt2 = this.nudgeTarget ? this.packs[this.nudgeTarget] : null;
      this.nudge.hidden = !alt2;
      if (alt2) {
        var ap = alt2.plans[0];
        var apct = alt2.price > 0 ? Math.round((1 - ap.price / alt2.price) * 100) : 0;
        this.nudge.textContent = 'Available on the ' + alt2.title + ': ' + m(ap.price) + ' per delivery' + (apct > 0 ? ' (' + apct + '% off)' : '') + '. Tap to switch.';
      }
    }
    var subPrice = plan ? plan.price : pack.price;
    var anchor = pack.compareAt > pack.price ? pack.compareAt : pack.price;
    // Component subscriptions (2/3-month): compare against the pieces at full price, not the bundle.
    var subBase = plan && plan.compare ? plan.compare : pack.price;
    var pct = plan && subBase > 0 ? Math.round((1 - plan.price / subBase) * 100) : 0;
    // "Arrives every month" perk follows the pack: every 2 months, every 3 months...
    var perks = this.root.querySelector('[data-sub-perks]');
    if (perks) {
      var months = plan ? (pack.months || 1) : 1;
      var every = months > 1 ? 'every ' + months + ' months' : 'every month';
      // Seal plans named "35-day / 70-day / 105-day subscription": say exactly that, so the product page,
      // cart and checkout all describe the same delivery interval.
      var dayMatch = plan && plan.name ? String(plan.name).match(/(\d+)\s*-?\s*day/i) : null;
      if (dayMatch) every = 'every ' + dayMatch[1] + ' days';
      perks.querySelectorAll('li').forEach(function (li) {
        if (!li.hasAttribute('data-orig')) li.setAttribute('data-orig', li.textContent);
        li.textContent = li.getAttribute('data-orig').replace(/every month/i, every);
      });
    }

    var q = function (sel) { return self.root.querySelector(sel); };
    if (!plan && this.nudgeTarget) {
      var np = this.packs[this.nudgeTarget];
      pct = np.price > 0 ? Math.round((1 - np.plans[0].price / np.price) * 100) : 0;
    }
    if (q('[data-sub-pct]')) q('[data-sub-pct]').textContent = pct > 0 ? pct + '%' : '';
    if (q('[data-sub-price]')) q('[data-sub-price]').textContent = plan ? m(subPrice) : '';
    var subAnchor = plan && plan.compare ? Math.max(plan.compare, anchor) : anchor;
    if (q('[data-sub-compare]')) q('[data-sub-compare]').textContent = plan && subAnchor > subPrice ? m(subAnchor) : '';
    if (q('[data-once-price]')) q('[data-once-price]').textContent = m(pack.price);
    if (q('[data-once-compare]')) q('[data-once-compare]').textContent = pack.compareAt > pack.price ? m(pack.compareAt) : '';

    Object.keys(this.planEls).forEach(function (k) {
      var el = self.planEls[k]; if (!el) return;
      el.classList.toggle('is-selected', k === self.plan);
      var i = el.querySelector('input'); if (i) i.checked = k === self.plan;
    });

    var unitPrice = this.plan === 'subscribe' && plan ? subPrice : pack.price;
    var qty = this.qtyInput ? Math.max(1, Number(this.qtyInput.value) || 1) : 1;
    this.qty = qty;
    var finalPrice = unitPrice * qty;
    var left = q('[data-summary-left]');
    if (left) {
      if (pack.tablets > 0) {
        var perTab = Math.round(unitPrice / pack.tablets);
        left.textContent = m(perTab) + ' per tablet · ' + Math.round(pack.tablets * qty / 2) + ' days of brushing';
      } else { left.textContent = qty > 1 ? qty + ' × ' + m(unitPrice) : ''; }
    }
    var right = q('[data-summary-right]');
    if (right) right.textContent = anchor > unitPrice ? 'You save ' + m((anchor - unitPrice) * qty) : '';
    var summary = q('.wt-summary'); if (summary) summary.hidden = !(left && left.textContent) && !(right && right.textContent);

    var label = this.plan === 'subscribe' && plan ? this.labelSub : this.labelOnce;
    this.root.querySelectorAll('[data-atc-label]').forEach(function (el) { el.textContent = (pack.available ? label + ' · ' + m(finalPrice) : 'Sold out'); });
    var shortScope = this.sticky || this.root;
    shortScope.querySelectorAll('[data-atc-label-short]').forEach(function (el) { el.textContent = pack.available ? (self.plan === 'subscribe' && plan ? 'Subscribe' : 'Add to cart') : 'Sold out'; });
    this.atcButtons.forEach(function (b) { b.disabled = !pack.available; });

    if (this.sticky) {
      var t = this.sticky.querySelector('[data-sticky-title]'); if (t) t.textContent = pack.title;
      var sp = this.sticky.querySelector('[data-sticky-price]'); if (sp) sp.textContent = m(finalPrice) + (this.plan === 'subscribe' && plan ? ' · subscription' : '');
    }

    this.root.dispatchEvent(new CustomEvent('wt:pack', { bubbles: true, detail: { pack: pack, plan: this.plan } }));
  };

  BuyBox.prototype.addToCart = function () {
    var self = this;
    var pack = this.packs[this.packId];
    if (!pack || !pack.available) return;
    var plan = this.plan === 'subscribe' ? this.currentPlan(pack) : null;
    var item = { id: pack.variantId, quantity: this.qty || 1 };
    if (plan) item.selling_plan = plan.id;
    var items = [item];
    if (plan && plan.items) {
      var n = this.qty || 1;
      items = plan.items.map(function (it) { return { id: it.id, quantity: it.quantity * n, selling_plan: it.selling_plan }; });
    }

    this.atcButtons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    if (this.errorEl) this.errorEl.hidden = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function () {
      document.dispatchEvent(new CustomEvent('wt:added', { detail: { pack: pack, plan: plan } }));
      if (self.atcAction !== 'checkout' && window.WTCart) {
        self.atcButtons.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
        window.WTCart.open().catch(function () { window.location.href = root + 'cart'; });
        return;
      }
      window.location.href = root + (self.atcAction === 'checkout' ? 'checkout' : 'cart');
    }).catch(function (err) {
      if (self.errorEl) {
        self.errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
        self.errorEl.hidden = false;
      }
      self.atcButtons.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
    });
  };

  BuyBox.prototype.initSticky = function () {
    var sticky = this.sticky;
    var main = this.root.querySelector('.wt-btn--block[data-wt-atc]');
    if (!sticky || !main || !('IntersectionObserver' in window)) return;
    document.body.appendChild(sticky); // escape any transformed parent
    // Phones: the bar shows whenever the main button is off screen, above or below it.
    // On the home offer, before the shopper reaches the selector it jumps there ("Choose my plan")
    // instead of adding a pack they have not seen; on product pages it adds the pre-selected pack.
    var root = this.root;
    var onPdp = !!root.closest('.wt-pdp');
    var btn = sticky.querySelector('button');
    var jump = document.createElement('span');
    jump.className = 'wt-sticky__jump';
    jump.textContent = 'Choose my plan';
    if (btn) btn.appendChild(jump);
    if (btn) btn.addEventListener('click', function (ev) {
      if (!sticky.classList.contains('is-jump')) return;
      ev.preventDefault(); ev.stopImmediatePropagation();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, true);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var notYet = e.boundingClientRect.top > 0;
        var show = !e.isIntersecting;
        sticky.classList.toggle('is-visible', show);
        sticky.classList.toggle('is-jump', show && notYet && !onPdp);
        sticky.setAttribute('aria-hidden', String(!show));
        if (btn) btn.tabIndex = show ? 0 : -1;
      });
    });
    io.observe(main);
  };

  // Offer-builder visual / PDP gallery follow the selected pack
  document.addEventListener('wt:pack', function (e) {
    var section = e.target.closest('[data-wt-section]');
    if (!section || !e.detail.pack.image) return;
    var img = section.querySelector('[data-wt-visual] img');
    if (img && img.getAttribute('data-src-current') !== e.detail.pack.image) {
      img.src = e.detail.pack.image;
      img.hidden = false;
      img.removeAttribute('srcset');
      img.setAttribute('data-src-current', e.detail.pack.image);
      img.alt = e.detail.pack.title;
      section.querySelectorAll('.wt-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
    }
  });

  function initGallery(root) {
    var main = root.querySelector('[data-wt-visual] img');
    root.querySelectorAll('.wt-gallery__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.getAttribute('data-full');
        main.removeAttribute('srcset');
        main.setAttribute('data-src-current', t.getAttribute('data-full'));
        root.querySelectorAll('.wt-gallery__thumb').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-wt-buybox]').forEach(function (el) {
      if (el.__wt) return; el.__wt = new BuyBox(el);
    });
    (scope || document).querySelectorAll('[data-wt-gallery]').forEach(function (el) {
      if (el.__wtg) return; el.__wtg = true; initGallery(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
